/**
 * Pedestal transform: consume-N scaling into mecha stats.
 *
 * GDD-SHARED baselines:
 *   mecha_hp  = 500 + N_pre * 40 + N_pre^1.1 * 2
 *   mecha_dps = 80 + N_pre * 8
 */
import { MECHA_DPS_BASE, MECHA_DPS_PER_UNIT, MECHA_HP_BASE, MECHA_HP_LINEAR, MECHA_HP_POWER_COEF, MECHA_HP_POWER_EXP, } from "./constants.js";
/** Pure formula: HP from N_pre (not floored until cast to stats). */
export function mechaHpFromN(nPre) {
    const n = Math.max(0, nPre);
    return MECHA_HP_BASE + n * MECHA_HP_LINEAR + Math.pow(n, MECHA_HP_POWER_EXP) * MECHA_HP_POWER_COEF;
}
/** Pure formula: DPS from N_pre. */
export function mechaDpsFromN(nPre) {
    const n = Math.max(0, nPre);
    return MECHA_DPS_BASE + n * MECHA_DPS_PER_UNIT;
}
/** Build mecha stats snapshot from pre-transform count. */
export function computeMechaStats(nPre) {
    const n = Math.max(0, Math.floor(nPre));
    const hp = Math.floor(mechaHpFromN(n));
    const dps = Math.floor(mechaDpsFromN(n));
    return { hp, maxHp: hp, dps, nPre: n };
}
/**
 * Can the pedestal fire?
 * - If minN set: require N >= minN
 * - Else: always (consume-all scaling, even N=0 yields base mecha)
 */
export function canTransform(n, pedestal) {
    if (pedestal.minN !== undefined) {
        return n >= pedestal.minN;
    }
    return true;
}
/**
 * Consume-all transform: returns mecha stats and post-transform N (= 0).
 * Does not mutate caller state.
 */
export function applyTransform(nPre) {
    const n = Math.max(0, Math.floor(nPre));
    return {
        mecha: computeMechaStats(n),
        nAfter: 0,
    };
}
/**
 * Optional consume-cost transform: spend `cost`, keep remainder N.
 * Prefer consume-all for ad-faithful fantasy; exposed for future content.
 */
export function applyTransformConsumeCost(nPre, cost) {
    const n = Math.max(0, Math.floor(nPre));
    const c = Math.max(0, Math.floor(cost));
    if (n < c)
        return null;
    return {
        mecha: computeMechaStats(c),
        nAfter: n - c,
    };
}
//# sourceMappingURL=transform.js.map